import React, { ReactNode } from 'react';
import { Typography, makeStyles, Box } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import classnames from 'classnames';

const styles = makeStyles(({ spacing, palette }: any) => ({
  billSummaryRow: {
    '&:last-child': {
      paddingBottom: spacing(2.5),
    },
    paddingLeft: spacing(3),
    paddingRight: spacing(3),
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
  pendingClass: {
    color: palette.text.secondary,
  },
  pendingPayment: {
    '&:last-child': {
      marginTop: spacing(1),
    },
    backgroundColor: palette.background.progress,
  },
  rightContent: {
    paddingTop: spacing(2),
    flexShrink: 0,
    flexGrow: 1,
  },
  leftContent: {
    paddingTop: spacing(2),
    paddingRight: spacing(3),
    textAlign: 'left',
    flexShrink: 1,
    flexGrow: 0,
  },
  redemptionFailure: {
    color: palette.error.main,
  },
  subTotal: {
    paddingTop: 0,
  },
  summarySpinner: {
    marginTop: spacing(2),
    marginRight: spacing(2),
  },
}));

interface SummaryLineProps {
  leftContent: string | ReactNode;
  rightContent: string;
  pending?: boolean;
  isPayment?: boolean;
  status?: string;
}

const SummaryLine = ({
  leftContent,
  rightContent,
  pending = false,
  isPayment = false,
  status = '',
  ...props
}: SummaryLineProps) => {
  const classes = styles({ isPayment, pending });

  const summaryClass = classnames(classes.billSummaryRow, {
    [classes.pendingClass]: pending && !isPayment,
    [classes.pendingPayment]: pending && isPayment,
  });

  return (
    <Box display="flex" className={summaryClass} {...props}>
      <Box>
        <Typography variant="body1" className={`${classes.leftContent} ${classes[status]}`}>
          <b>{leftContent}</b>
        </Typography>
      </Box>
      <Box>
        <Box display="flex">
          {pending && isPayment && (
            <CircularProgress className={classes.summarySpinner} size="1rem" />
          )}
          <Typography
            variant="body1"
            align="right"
            className={`${classes.rightContent} ${classes[status]}`}
          >
            <b>{rightContent}</b>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SummaryLine;
